import Box from "@mui/material/Box";
import { alpha } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";

import { useParams } from "react-router-dom";
// import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
// import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
// import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import {
  BlockChain,
  DRCoreApi,
  DownloadApi,
  FileLoader,
  UploadApi,
  keyImages,
} from "../constants/Constants";
// import { SmileOutlined } from "@ant-design/icons";
// import getDCMCloudUrl from "../utilities/BaseKey";
import EditIcon from "@mui/icons-material/Edit";
import GetAppIcon from "@mui/icons-material/GetApp";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import { Buffer } from "buffer";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AlertDialogSlide from "./AlertDialogSlide";
import CustomizedSnackbars from "./CustomizedSnackbars";
import DatatablePage from "./DatatablePage";
import SidePanel from "./ModCardPanel/SidePanel";
// import SimCardDownloadOutlinedIcon from "@mui/icons-material/SimCardDownloadOutlined";
import axios from "axios";
// import { CircularProgress } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import cogoToast from "cogo-toast";
import { useDispatch } from "react-redux";
import Folder from "../../src/asstes/Folder2.png";
import Home from "../../src/asstes/Home.png";
import LeftArrow from "../../src/asstes/LeftArrow.png";
import { foldersave, setbuttonTop } from "../app/features/counterSlice";
import "../components/resPanel.css";
import {
  AWS_Access_Key_Id,
  AWS_Access_Key_Id_Encypt,
  AWS_Bucket_Name,
  AWS_Region,
  AWS_Secret_Access_Key,
  AWS_Secret_Access_Key_Encypt,
} from "../constants/bucketCostant";

import { useDicomDownload, DownloadProgressPanel } from '../utilities/useDicomDownload';

// import Card from '@material-ui/core/Card';
// import CardActions from '@material-ui/core/CardActions';
// import CardContent from '@material-ui/core/CardContent';
// import { Link } from "@mui/material";

const rows = [];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly

const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Patient name",
  },
  {
    id: "mrn",
    numeric: false,
    disablePadding: false,
    label: "MRN",
  },
  {
    id: "Accession",
    numeric: false,
    disablePadding: false,
    label: "Accession",
  },
  {
    id: "Study Date",
    numeric: false,
    disablePadding: false,
    label: "Study Date",
  },
  {
    id: "modality",
    numeric: false,
    disablePadding: false,
    label: "Modality",
  },
  {
    id: "bucket",
    numeric: false,
    disablePadding: true,
    label: "Bucket",
  },
];

const columns = [
  {
    label: "Patient Name",
    field: "name",
    sort: "asc",
    width: 150,
  },
  // {
  //   label: "MRN",
  //   field: "mrn",
  //   sort: "asc",
  //   width: 100,
  // },
  // {
  //   label: "Accession",
  //   field: "Accession",
  //   sort: "asc",
  //   width: 100,
  // },
  {
    label: "Study Date",
    field: "Study Date",
    sort: "asc",
    width: 100,
  },
  // {
  //   label: "Modality",
  //   field: "modality",
  //   sort: "asc",
  //   width: 100,
  // },
  {
    label: "Bucket",
    field: "bucket",
    sort: "asc",
    width: 100,
  },
  {
    label: "Actions",
    field: "action",
    sort: "asc",
    width: 70,
  },
];

function EnhancedTableHead2(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const [studies, setStudies] = React.useState([]);
  const [rows, setRows] = React.useState("");

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          {/* <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    /> */}
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              <b>{headCell.label}</b>
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead2.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    <>
      <Typography
        sx={{ flex: "1 1 100%" }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Study List
      </Typography>
      <Toolbar
        sx={{
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
          ...(numSelected > 0 && {
            bgcolor: (theme) =>
              alpha(
                theme.palette.primary.main,
                theme.palette.action.activatedOpacity
              ),
          }),
        }}
      >
        {numSelected > 0 ? (
          <Tooltip title="Delete">
            <IconButton>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : (
          ""
        )}
      </Toolbar>
    </>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function ModalityCards({
  setIframeValue,
  setDisplayIFrame,
  setTab,
  setPassword,
}) {
  const [order, setOrder] = React.useState("asc");
  const dispatch = useDispatch();
  const { modality, FolderName, subFolder, thirdFolder, fourthFolder } =
    useParams();
  const aa = useParams();
  const FolderGet = useSelector((state) => state.FolderGet.FolderName);
  const MainFolder = FolderName?.split("%");
  const SubFolder = subFolder?.split("%");
  // Join the MainFolder back together to get the cleaned value
  const cleanedValue = MainFolder?.join("");
  // //console.log(lab, "lab");
  const navigate = useNavigate();
  const [formation, setformation] = React.useState([]);
  const [Filter, setFilter] = React.useState([]);
  const [studies, setStudies] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState([]);
  const [studiesdata, setstudiesdata] = React.useState([]);
  const [cOpen, setCOpen] = React.useState(false);
  const [cOpen1, setCOpen1] = React.useState(false);
  const [cEmail, setCEmail] = React.useState("");
  const [cAccession, setCAccession] = React.useState("");
  const [cPass, setCPass] = useState("");
  const [isOpen, setIsOpen] = React.useState(false);
  const [severity, setSeverty] = React.useState("success");
  const [message, setMessage] = React.useState("link copied to clipboard.");
  const state = useSelector((state) => state.user);
  const storedDataJSON = localStorage.getItem("studies");
  const [isSidePanelOpen, setIsSidePanelOpen] = React.useState(false);
  const [SSuid, setSsuid] = React.useState("");
  const [modalEditCase, setModalEditCase] = useState(false);
  const [ModalData, setModalData] = useState([]);
  const [CaseName, setCaseName] = useState("");
  const token = localStorage.getItem("token");
  const CanUpload = useSelector((state) => state.isUpload);
  const isOnlyKeyImages = useSelector((state) => state.isOnlyKeyImages);
  const { downloadDicom, downloads, removeDownload } = useDicomDownload();

  const goBack = () => {
    // Use navigate to go back to the previous page
    navigate(`/SubFolder&studies/${FolderName}`);
    dispatch(setbuttonTop(false));
    // dispatch(setbuttonTop(false));
    setTab(4);
  };
  // Convert the JSON string back to an array of objects
  const storedData = JSON.parse(storedDataJSON);

  // const downloadDicom = async (studyInstanceUID, e) => {
  //   const bucket = localStorage.getItem("currentbucket");
  //   const parsedData = JSON.parse(bucket);

  //   const requestBody = {
  //     args: [studyInstanceUID, state.email],
  //     email: state.email,
  //     orgName: "patient",
  //     fcn: "downloadDicomFile",
  //   };

  //   let csvURL = `${DownloadApi}/dicomzip?Bucket=${encodeURIComponent(
  //     AWS_Bucket_Name()
  //   )}&path=${MainFolder}${SubFolder ? "/" + SubFolder : ""}${
  //     thirdFolder ? "/" + thirdFolder : ""
  //   }${
  //     fourthFolder ? "/" + fourthFolder : ""
  //   }/${studyInstanceUID}&region=${encodeURIComponent(
  //     AWS_Region()
  //   )}`;

  //   var tempLink = document.createElement("a");
  //   tempLink.href = csvURL;
  //   tempLink.click();
  //   try {
  //     // const response = await axios.post(
  //     //   `${BlockChain}/api/give-access`,
  //     //   requestBody,
  //     //   {
  //     //     headers: {
  //     //       "Content-Type": "application/json",
  //     //       Authorization: `Bearer ${token}`,
  //     //     },
  //     //   }
  //     // );
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // var user=localStorage.getItem('persist:root')
  // //console.log('user',user)

  // setFilter(statestudies)
  // Avoid a layout jump when reaching the last page with empty rows.
  // const emptyRows =
  //   page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const viewStudy = (
    folderName,
    awsbucketname,
    awsAccessKeyId,
    awsSecretAccessKey,
    dcmcaccesskey,
    password
  ) => {
    dispatch(foldersave({ folder: folderName }));
    setStudies([]);
    setLoading(true);
    axios
      .post("https://key-images-vercel.vercel.app/api/v1/keyImages/base", {
        Foldername: folderName,
        Bucket_Name: awsbucketname,
        AccessKey_Id: awsAccessKeyId,
        SecretAccess_Key: awsSecretAccessKey,
        dcmcAccesskey: dcmcaccesskey,
      })
      .then(function (response) {
        setPassword(password);
        setIframeValue(response.data.url);
        setDisplayIFrame(true);
      });
  };

  function downloadFile(filePath) {
    var link = document.createElement("a");
    link.href = filePath;
    // link.target = "_blank"
    link.download = filePath.substr(filePath.lastIndexOf("/") + 1);
    link.click();
  }

  var pAccession;
  const clickHandler = async (item) => {
    let suid = item.SUID || "";

    const requestBody = {
      args: [suid],
      email: state.email,
      orgName: "dcm",
      fcn: "viewDicomFile",
    };

    try {
      const response = await axios.post(
        `${BlockChain}/api/view-dicom`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      console.error(error);
    }

    let pName = item.patientName;
    let pModality = item.modalityType;
    // let pAccession = item["00080050"]?item["00080050"].Value[0]:"N/A"?item["00080050"].Value[0]:'N/A';
    if (item.accession) {
      pAccession = item.accession;
    } else {
      pAccession = "N/A";
    }
    axios
      .post(`http://192.168.18.19:8080/api/view/CLIENT${state.id}`, {
        patientName: pName,
        customerID: state.email,
        modality: pModality,
        accession: pAccession,
      })
      .then((response) => response.json())
      .then((result) => console.log("result", result))
      .catch((error) => console.log("error", error));
  };

  // ==== Share Data hyperledge===

  const DownloadStudy = async (data) => {
    let base64ToString = new Buffer.from(
      `${AWS_Bucket_Name()}^${AWS_Access_Key_Id_Encypt()}^${AWS_Secret_Access_Key_Encypt()}^null^null`
    ).toString("base64");
    const hello = await fetch(
      `${DRCoreApi}/react/WadoRS/studies/${data}^${base64ToString}/metadata`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    const resp = await hello.json();
    if (resp) {
      resp.map(async (item) => {
        downloadFile(
          `${DRCoreApi}/react/WadoURI?requestType=WADO&studyUID=${item["0020000D"].Value[0]}&seriesUID=${item["0020000E"].Value[0]}&objectUID=${item["00080016"].Value[0]}&contentType=application/dicom&transferSyntax=*&key=QUtJQVVaUzU0NlBWRURTMlJSWVA=`
        );
      });
    }
  };

  const deleteStudy = (args) => {
    var data = [];
    //  localStorage.getItem("deleteStudy")
    if (!localStorage.getItem("deleteStudy")) {
      data.push(args);
      localStorage.setItem("deleteStudy", JSON.stringify(data));
      setMessage("Deleting Study...");
      setIsOpen(true);
      setTimeout(() => {
        setIsOpen(false);
        window.location.reload();
      }, 2000);
    } else {
      data = JSON.parse(localStorage.getItem("deleteStudy"));
      data.push(args);
      localStorage.setItem("deleteStudy", JSON.stringify(data));
      setMessage("Deleting Study...");
      setIsOpen(true);
      setTimeout(() => {
        setIsOpen(false);
        window.location.reload();
      }, 2000);
    }
  };

  const fetchDataFromApi = async (dataa) => {
    const requestBody = {
      args: [dataa],
      email: state.email,
      orgName: "dcm",
      fcn: "viewDocument",
    };

    try {
      let token = localStorage.getItem("token");
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const promises = [];

      const formData = {
        AwsBucket: AWS_Bucket_Name(),
        suid: `${MainFolder}${
          SubFolder ? "/" + SubFolder : ""
        }/${dataa}/Reports`,
      };

      const response = await axios.post(
        `${keyImages}/keyImages/v1/PdfNode/getPdf`,
        JSON.stringify(formData),
        { headers }
      );

      if (response) {
        toggleSidePanel(response.data);
        setMessage("Folder Updated Successfully");
        setTimeout(() => {
          setIsOpen(false);
        }, 3000);
      }
    } catch (error) {
      cogoToast.error("Report is not available", {
        position: "top-right",
      });
      console.error("Error while deleting folder:aa", error);
    }
    // blockChain Api
    try {
      // const response = await axios.post(
      //   `${BlockChain}/api/view-document`,
      //   requestBody,
      //   {
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
    } catch (error) {
      console.error(error);
    }
  };
  const EditCase = async () => {
    // Create a new FormData object
    const formData = new FormData();

    // Append necessary data to the formData object
    formData.append("awsbucketname", AWS_Bucket_Name());
    formData.append("awsAccessKeyId", AWS_Access_Key_Id_Encypt());
    formData.append("awsSecretAccessKey", AWS_Secret_Access_Key_Encypt());
    formData.append(
      "DCMCAccessKey",
      process.env.React_App_User_DCMC_Access_Key_encypt
    );
    formData.append("Region", AWS_Region());
    formData.append("value", CaseName);
    formData.append("tag", "00100010");

    try {
      // Retrieve token from local storage
      const token = localStorage.getItem("token");

      // Construct the URL for the API endpoint
      const url = `${FileLoader}/fileloaderv1/files/EditCasebySUID?Foldername=${MainFolder}${
        SubFolder ? "/" + SubFolder : ""
      }/&SUID=${ModalData.SUID}`;

      // Make the POST request using axios
      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // setModalEditCase(false);
      // fetchStudies();
      // filterdata();
      if (response) {
        setModalEditCase(false);
        await fetchStudies();
        // filterdata();
      }
      // Log the response
    } catch (error) {
      // Log any errors
      setModalEditCase(false);
    }
  };
  const convertDate = (inputDate) => {
    // Extract year, month, and day from the inputDate string
    const year = inputDate.substring(0, 4);
    const month = inputDate.substring(4, 6);
    const day = inputDate.substring(6, 8);

    // Concatenate the year, month, and day in the ISO date format
    const isoDate = `${year}-${month}-${day}`;

    return isoDate;
  };

  const fetchStudies = async () => {
    const formationOfData = [];
    const token = localStorage.getItem("token");
    const value = localStorage.getItem("jkbnm");
    let isShared = value === "dmewtnwkndghn" ? true : false;
    // //console.log(state.email, "user email");
    // const formatedData = []
    try {
      const formData = new FormData();
      formData.append(
        "folderName",
        `${MainFolder}${subFolder !== undefined ? "/" + subFolder : ""}${
          thirdFolder !== undefined ? "/" + thirdFolder : ""
        }${fourthFolder !== undefined ? "/" + fourthFolder : ""}`
      );
      formData.append("bucketName", AWS_Bucket_Name());
     
      formData.append("Region", AWS_Region());

      const hello = await fetch(`${UploadApi}/apiUpload/GetData`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const resp = await hello.json();
      var studies = [];
      resp?.data.filter((item) => {
        if (
          state.email === "operations@medicalrecordcollation.com" ||
          "ziad@gmail.com" ||
          "danish@gmail.com"
        ) {
          formationOfData.push({
            ssuid: item?.SUID ? item.SUID : "",
            name: item?.patientName ? item.patientName : "N/A",
            mrn: item?.mrn ? item.mrn : "N/A",
            Accession: item?.accession ? item.accession : "",
            "Study Date": item.studyDate ? convertDate(item.studyDate) : "",
            modality: item?.modalityType ? item.modalityType : "",
            modalityLab: item["00081030"]
              ? item["00081030"].Value[0]
              : "Not Available",
            modalityDes: item?.modalityDescription
              ? item.modalityDescription
              : "Not Available",
            // ssuid: item["0020000D"] ? item["0020000D"].Value[0] : "",
            foldername: `${MainFolder}${
              SubFolder != undefined ? "/" + SubFolder : ""
            }`,
            // name: item["00100010"] ? item["00100010"].Value[0]?.Alphabetic : "",
            // mrn: item["00100020"] ? item["00100020"].Value[0] : "",
            // Accession: item["00080050"] ? item["00080050"].Value[0] : "",
            // "Study Date": item["00080020"]
            //   ? convertDate(item["00080020"].Value[0])
            //   : "",
            // modality: item["00080060"] ? item["00080060"].Value[0] : "",
            // modalityLab: item["00081030"]
            //   ? item["00081030"].Value[0]
            //   : "Not Available", // Set to "Not Available" if it doesn't exist
            // modalityDes: item["00081030"]
            //   ? item["00081030"].Value[0]
            //   : "Not Available", // Set to "Not Available" if it doesn't exist
            action: (
              <>
                {!isOnlyKeyImages && (
                  <Tooltip title="View Dicom  ">
                    <i
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        dispatch(setbuttonTop(true));
                        viewStudy(
                          item.SUID,
                          AWS_Bucket_Name(),
                          AWS_Access_Key_Id_Encypt(),
                          AWS_Secret_Access_Key_Encypt(),
                          process.env.React_App_User_DCMC_Access_Key_encypt,
                          item.patientName
                        );
                        // clickHandler(item);
                        // navigate('/')
                        setTab(0);
                        setDisplayIFrame(true);
                      }}
                    >
                      <RemoveRedEyeIcon />
                    </i>
                  </Tooltip>
                )}
                &nbsp;
                {(!FolderGet || CanUpload) && !isOnlyKeyImages && (
                  <>
                    {/* <Tooltip title="Share credentials">
                      <i
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          var email = item["00100010"].Value[0]?.Alphabetic;
                          var pass = item["00100020"]
                            ? item["00100020"].Value[0]
                            : item["00100010"].Value[0]?.Alphabetic;
                          var data = item["0020000D"]?.Value[0];
                          //console.log("data", data, email);
                          setCAccession(data);
                          setCEmail(email);
                          setCPass(pass);
                          setCOpen(true);
                        }}
                      >
                        <ShareIcon />
                      </i>
                    </Tooltip> */}
                    &nbsp;
                    <Tooltip title="Upload PDF">
                      <i
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          viewStudy(
                            item.SUID,
                            AWS_Bucket_Name(),
                            AWS_Access_Key_Id_Encypt(),
                            process.env.React_App_User_AWS_Secret_Access_Key_Encypt(),
                            process.env.React_App_User_DCMC_Access_Key_encypt,
                            item.patientName
                          );
                          // clickHandler(item);

                          addLabs(modality, FolderName, item.SUID);
                        }}
                      >
                        <UploadIcon />
                      </i>
                    </Tooltip>
                    &nbsp;
                    {/* <CopyToClipboard
                      text={`link: ${window.location.origin}/signin/${
                        item["00100010"].Value[0]?.Alphabetic
                      }-${
                        item["00100020"]
                          ? item["00100020"].Value[0]
                          : item["00100010"].Value[0]?.Alphabetic
                      }
                    email: ${item["00100010"]?.Value[0]?.Alphabetic}
                    password: ${
                      item["00100020"]
                        ? item["00100020"]?.Value[0]
                        : item["00100010"]?.Value[0]?.Alphabetic
                    }`}
                    >
                      <i
                        style={{ cursor: "pointer" }}
                        title="copy url"
                        onClick={() => {
                          // setMessage("link copied to clipboard.");
                          // setIsOpen(true);
                          // setTimeout(() => {
                          //     setIsOpen(false)
                          // }, 2000);
                          var email = item["00100010"]?.Value[0]?.Alphabetic;
                          var pass = item["00100020"]
                            ? item["00100020"]?.Value[0]
                            : item["00100010"]?.Value[0]?.Alphabetic;
                          var data = item["0020000D"]?.Value[0];
                          setCAccession(data);
                          setCEmail(email);
                          setCPass(pass);
                          setCOpen1(true);
                        }}
                      >
                        <ContentCopyIcon />
                      </i>
                    </CopyToClipboard>
                    &nbsp; */}
                  </>
                )}
                {!isOnlyKeyImages && (
                  <i
                    // style={{ cursor: "pointer" }}
                    className={`${
                      item.isDocument ? "cursor-pointer" : "cursor-not-allowed"
                    }`}
                    onClick={() => {
                      var email = item.patientName;
                      var pass = item.accession
                        ? item.accession
                        : item.patientName;
                      var dataa = item.SUID;

                      // setCAccession(data);
                      // setCEmail(email);
                      // setCPass(pass);

                      if (item.isDocument) {
                        fetchDataFromApi(dataa);
                      }
                    }}
                  >
                    <Tooltip title="View Document">
                      <SimCardDownloadIcon style={{ color: "red" }} />
                    </Tooltip>
                  </i>
                )}
                &nbsp;
                  <Tooltip title="Download Study">
                    <GetAppIcon
                      style={{ cursor: "pointer" }}
                      onClick={(e) => downloadDicom(
  `${MainFolder}${SubFolder ? "/" + SubFolder : ""}${thirdFolder ? "/" + thirdFolder : ""}${fourthFolder ? "/" + fourthFolder : ""}/${item.SUID}`,
  e
)}
                    />
                  </Tooltip>
                {!FolderGet && !isOnlyKeyImages && (
                  <Tooltip title="Edit Case">
                    <EditIcon
                      style={{ cursor: "pointer" }}
                      onClick={
                        () => {
                          setModalEditCase(true);
                          setModalData(item);
                          setCaseName(item.patientName ? item.patientName : "");
                        }
                        // (e) => EditCase(item)
                      }
                    />
                  </Tooltip>
                )}
              </>
            ),
          });
          setformation(formationOfData);
          const filteredData = formationOfData?.filter(
            (e, i) => e?.modality === modality
          );
          setFilter(filteredData);
          // setFilter(filteredData);

          // const encounteredModalityLabs = new Set();
          // //console.log("After pushing data 2", formationOfData);

          // for (const item of formationOfData) {
          //   if (!encounteredModalityLabs.has(item.modalityLab)) {
          //     encounteredModalityLabs.add(item.modalityLab);
          //     filteredData.push(item);
          //   }
          // }
          // setFilter(filteredData);
          //   setformation(prevFormation => [...prevFormation,{name: item["00100010"] ? item["00100010"].Value[0].Alphabetic : "",
          //   mrn: item["00100020"] ? item["00100020"].Value[0] : "",
          //   Accession: item["00080050"] ? item["00080050"].Value[0] : "",
          //   "Study Date": item["00080020"] ? item["00080020"].Value[0] : "",
          //   modality: item["00080060"] ? item["00080060"].Value[0] : "",
          //   modalityLab: item["00081010"] ? item["00081010"].Value[0] : "Not Available",
          // }])
        }
      });

      //       setStudies(formatedData);
      //       //console.log(formatedData,"formatedDatas");
      setData({
        columns,
        rows: studies,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const filterdata = () => {
    let filter = studiesdata.filter((e, i) => e?.modality === modality);
    setFilter(filter);
  };

  const addLabs = (modality, FolderName, ssuid) => {
    // const currentPathname = location.pathname;
    // //console.log(modality, FolderName, ssuid,SubFolder, "nsa9incsa98n");
    try {
      setTab(1);
      navigate(
        `/Upload/${FolderName}${
          SubFolder ? "/" + SubFolder : ""
        }/${modality}/${ssuid}`
      );
    } catch (error) {
      console.error("Navigation error:", error);
    }
  };

  React.useEffect(() => {
    fetchStudies();
    filterdata();
  }, []);

  const toggleSidePanel = (data) => {
    setSsuid(data);
    setIsSidePanelOpen(!isSidePanelOpen);
  };

  return (
    <>
      <div className=" w-10/12 text-xs md:test-sm bg-white border h-12 rounded-xl mt-1.5 text-purple-800  shadow-md mx-auto overflow-hidden ">
        <div className="inline-flex w-full h-full items-start justify-start  ">
          <div className="flex cursor-pointer mx-3 my-auto" onClick={goBack}>
            {" "}
            <img src={LeftArrow} height="20px" width="20px" alt="img" />
          </div>

          <div className="flex cursor-pointer font-bold my-auto">
            {" "}
            <img
              src={Folder}
              className="mx-2"
              height="20px"
              width="20px"
              alt="img"
            />
            My Folder
          </div>
          <div
            className="flex cursor-pointer  font-bold text-xs my-auto"
            onClick={() => {
              // setTab(5);
              // navigate("/");
            }}
          >
            {" "}
            <img
              src={Home}
              className="mx-2"
              height="20px"
              width="22px"
              alt="img"
            />
            Home / {MainFolder && MainFolder} / {SubFolder}
          </div>
        </div>
      </div>
      {/* Edit Case Details */}
      <div style={{ background: "rgba(0, 0, 0, 0.12)", marginTop: "-10px" }}>
        <Dialog
          open={modalEditCase}
          style={{ height: "60%" }}
          PaperProps={{
            style: {
              height: "50%",
            },
          }}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ margin: "auto", color: "#1976D2" }}>
            {"Edit Case Details"}
          </DialogTitle>
          <DialogContent style={{ overflowX: "hidden", marginLeft: 5 }}>
            <DialogContentText id="alert-dialog-slide-description">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Grid container spacing={2} style={{ marginTop: "-35px" }}>
                  <Grid item lg={12} style={{ paddingLeft: 23 }}>
                    <br />
                    <TextField
                      onChange={
                        (e) => {
                          setCaseName(e.target.value);
                          // //console.log(CaseName,"e.target.valuee.target.value");
                        }
                        // (e) => setEmailValue(e.target.value)
                      }
                      autoFocus
                      hiddenLabel
                      required
                      value={CaseName}
                      label="Name"
                      variant="outlined"
                      size="small"
                      type={"text"}
                      style={{
                        borderRadius: "3px",
                        backgroundColor: "white",
                        width: 538,
                        marginTop: "5px",
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ marginRight: "22px", marginBottom: "10px" }}>
            <Button
              onClick={
                () => {
                  setModalEditCase(false);
                }

                // () => dispatch(setmodalEditCase(false))
              }
            >
              Cancel
            </Button>
            <Button variant="contained" onClick={(e) => EditCase()}>
              Edit
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <div className=" flex justify-center items-center mx-auto w-full ">
        <div className=" w-10/12 mx-auto">
          <div
            className={`modality-cards-container${
              isSidePanelOpen ? " panel-open" : ""
            } mt-10`}
          >
            <Box sx={{ width: "100%" }} xs={12}>
              <Paper sx={{ width: "100%", mb: 1 }}>
                {
                  Filter?.length > 0 ? (
                    <div style={{ borderRadius: "8px" }}>
                      <DatatablePage
                        data={Filter}
                        mod={modality}
                        lab={cleanedValue}
                        setformation={setformation}
                      />
                    </div>
                  ) : loading ? (
                    <div
                      style={{
                        textAlign: "center",
                        height: "30vh",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        color: "grey",
                      }}
                    >
                      Loading...
                    </div>
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        height: "30vh",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {/* <Empty description={false} /> */}
                      <p style={{ fontSize: "14px", color: "gray" }}>
                        No Record Found!
                        <a onClick={() => setTab(1)}> Click Here </a>
                        to upload Images.
                      </p>
                    </div>
                  )
                  // </div>
                }

                <SidePanel
                  isOpen={isSidePanelOpen}
                  onClose={toggleSidePanel}
                  ssuidDetail={SSuid}
                />
              </Paper>

              <AlertDialogSlide
                cOpen={cOpen}
                setCOpen={setCOpen}
                email={cEmail}
                cAccession={cAccession}
                pass={cPass}
              />
              {/* <AlertDialogSlide2
            cOpen={cOpen1}
            setCOpen={setCOpen1}
            email={cEmail}
            cpass={cPass}
            cAccession={cAccession}
          /> */}
            </Box>
            <CustomizedSnackbars
              isOpen={isOpen}
              severity={severity}
              message={message}
            />
          </div>
        </div>
      </div>
      <DownloadProgressPanel downloads={downloads} removeDownload={removeDownload} />
    </>
  );
}
